<template>
  <div style="height: 100%">
    <el-form ref="form" :model="form" :rules="rules">
      <div style="padding: 10px 0">
        <el-select v-model="changeModuleCharts" collapse-tags filterable placeholder="请选择" @change="click">
          <el-option v-for="item in moduleCharts" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>

        <el-button class="btn default" style="margin-left: 20px" v-preventReClick @click="cancel">取 消</el-button>
        <el-button class="btn primary" type="primary" v-preventReClick @click="submit">确 定</el-button>
      </div>

      <input type="text" class="t" prop="name" value="例如：SPD运营监控中心" v-model="form.name" placeholder="请输入大屏报表名称" />
    </el-form>
    <div class="a btn-close" id="body">
      <div class="drag-box" :style="item.style" v-for="(item, index) in myCharts" v-drag="xyChange" :key="item.id"
        :id="'drag' + index" :ref="'drag' + index">
        <!-- v-drag -->
        <component v-bind:is="item.chart" :width="item.width" :height="item.height" :ref="'chart' + index"
          :name="item.name" @SizeChange="sizeChange" @StateChange="stateChange"></component>
      </div>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import { GetLargescreenById, SaveLargescreen, GetLargeScreenComponents } from "@/api";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin],
  components: {},
  data () {
    return {
      myCharts: [],
      name: "",
      details: [],
      form: {},
      moduleCharts: [],
      changeModuleCharts: [],
      isFullscreen: false, //是否全屏
      rules: {
        name: [
          {
            required: true,
            message: "大屏名称不能为空",
            trigger: "blur",
          },
        ],
      },
      xChangeValue: [],
      yChangeValue: [],
    };
  },
  methods: {
    handleUpdate (id) {
      GetLargescreenById({
        id,
      }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        // let bodyEl = document.getElementById('body');
        this.title = "编辑";

        var parentNode = document.getElementById("body");
        let bdWidth = parentNode.offsetWidth;
        let bdHeight = parentNode.offsetHeight;
        let bdX = parentNode.offsetLeft;
        let bdY = parentNode.offsetTop;
        console.log(bdHeight,'x',bdWidth,'y');
        
        this.form.details.forEach((item) => {
          item.chart = () => import(`@/views/${item.component}`);
          item.state = 1;
          item.name = item.showState == 1 ? item.name : "";
          let clientX = (item.clientX * bdWidth + bdX ).toFixed(4) * 1;
          let clientY = (item.clientY * bdHeight + bdY) .toFixed(4) * 1;;
          console.log(clientX,clientY,11);
          
          let width = bdWidth * item.width;
          let height = bdHeight * item.height;
          // let xRatio = ((chartX - bdX) / bdWidth).toFixed(4) * 1
          // let yRatio = ((chartY - bdY) / bdHeight).toFixed(4) * 1

          item.style = {
            width: width + "px",
            height: height + "px",
            top: clientY + "px",
            left: clientX + "px",
          };
          this.myCharts.push(item);
        });
      });
    },
    
    // 保存
    submit () {
      // this.$refs["form"].validate((valid) => {
      //   if (!valid) {
      //     return false;
      //   }
      // console.log(this.form.name, "name")
      if (this.form.name == "" || this.form.name == null) {
        this.$my_message(`大屏名称不能为空`, "warning");
        return;
      }
      this.form.details = this.myCharts.filter((e) => e.state == 1);
      this.form.orgCode = sessionStorage.getItem('orgId');
      SaveLargescreen(this.form).then((res) => {
        this.$my_message(`执行成功`, "success");
        sessionStorage.setItem("editMode", 0);
        // this.$router.push({ path: this.getMainPath(this.$route.path) });
        this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
      });
      // });
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },
    // 获取列表
    getData () {
      GetLargeScreenComponents({
        ...this.defaultAllQueryParams,
      }).then((res) => {
        this.moduleCharts = res.returnData.data;
        // console.log(this.moduleCharts, "this.moduleCharts ");
      });
    },
    click (id) {
      let bodyEl = document.getElementById("body");
      // console.log(bodyEl, 'body')
      var item = this.moduleCharts.find((e) => e.id == id);
      
      if (this.myCharts.find((e) => e.moduleId == id && e.state != 0)) {
        this.$my_message("当前图表已存在", "warning");
        return;
      }
      // 第一次加载出来报表，如果没有缩放，要默认计算一下宽高
      console.log("加载前：", "w", item.width, "h", item.height);
      let width = (item.width / bodyEl.offsetWidth).toFixed(4) * 1; //w;
      let height = (item.height / bodyEl.offsetHeight).toFixed(4) * 1; //h;
      console.log("计算后：", "w", width, "h", height);

      console.log("加载前：", "y", item.clientY, "x", item.clientX);
      let x = (bodyEl.offsetWidth / bodyEl.offsetLeft / 1000).toFixed(4) * 1; //x;
      let y = (bodyEl.offsetHeight / bodyEl.offsetTop / 1000).toFixed(4) * 1; //y;
      console.log("计算后：", "y", y, "x", x);

      // var path = item.component.replace(/workBench[/]largescreen/, ".");
      let chartForm = {
        chart: () => import(`@/views/${item.component}`),
        // chart: () => import(`${path}`),
        clientX: x, //bodyEl.offsetLeft,//185,
        clientY: y, //bodyEl.offsetTop,//143,
        width: width,
        height: height,
        moduleId: item.id, // 模块id
        name: item.showState == 1 ? item.name : "",
        state: 1, // 如果删除了，把这个改为0
        style: {
          width: item.width + "px",
          height: item.height + "px",
          top: item.clientY + "px",
          left: item.clientX + "px",
        },
      };
      this.myCharts.push(chartForm);
      // console.log(this.myCharts, "this.myCharts");
    },
    sizeChange (w, h, domId) {
      
      // 拿到e对应的index
      // 拿到this.myCharts里面对应的数据，给x、y赋值
      var parentNode = document.getElementById("body");
      let bdWidth = parentNode.offsetWidth; // 背景图的宽
      let bdHeight = parentNode.offsetHeight; //背景图的高
      // console.log('bdWidth', bdWidth, 'bdHeight', bdHeight)
      let index = domId.slice(4);
      if (this.myCharts[index] != null) {
        let width = (w / bdWidth).toFixed(4) * 1; //w;
        let height = (h / bdHeight).toFixed(4) * 1; //h;
        // console.log(width,'width',height,'height');

        this.myCharts =  this.myCharts.map((res,i)=>{
          if(i == index){
            res.width = width
            res.height = height
            res.style.height =  h 
            res.style.width = w 
          }
          return res
        })
      }
    },
    stateChange (s, domId) {
      // 把隐藏的图例状态改成0
      // console.log("s", s, "domId", domId, "stateChange");
      let index = domId.slice(4);
      if (this.myCharts[index] != null) {
        this.myCharts[index].state = s;
      }
    },
    xyChange (e, domId) {
      // console.log("e", e, "domId", domId, "xyChange");
      var parentNode = document.getElementById("body");
      var box = document.getElementById(domId);
      let bdWidth = parentNode.offsetWidth; // 背景图的宽
      let bdHeight = parentNode.offsetHeight; //背景图的高
      let bdX = parentNode.offsetLeft; //距离左边位置
      let bdY = parentNode.offsetTop; //距离顶部位置
      // console.log('bdx', parentNode.clientX, 'bdy', parentNode.clientY)
      var index = domId.slice(4);
      var arr = [];
      if (this.myCharts[index] != null) {
        let chartX = e.clientX - e.offsetX; // x的具体位置
        let chartY = e.clientY - e.offsetY; // y的具体位置
    
        // console.log(x, y, "x,y");
        // console.log(chartX, chartY, "chartX");
        // let chartX = e.pageX - e.offsetX; // x的具体位置
        // let chartY = e.pageY - e.offsetY; // y的具体位置
        // 鼠标移动时x,y轴赋值
        // 计算相对位置比例
        // 报表离背景图左侧的距离：chartX - bdX
        // 报表离背景图顶部的距离：chartY - bdY

        // 计算比例：
        let xRatio = ((chartX - bdX) / bdWidth).toFixed(4) * 1;
        let yRatio = ((chartY - bdY) / bdHeight).toFixed(4) * 1;
        
        // console.log(box.offsetParent.offsetWidth);

        // console.log((x -box.));
        // 移动位置超出，给默认最小值
        if (xRatio < 0 || yRatio < 0) {
          xRatio = 0.0086;
          yRatio = 0.0046;
        }
        this.myCharts =  this.myCharts.map((res,i)=>{
          if(i == index){
            res.clientX = xRatio
            res.clientY = yRatio
            res.style.top =  chartY 
            res.style.left = chartX 
            
          }
          return res
        })

        // this.myCharts[index].clientX = xRatio;
        // this.myCharts[index].clientY = yRatio;
      }
    },
  },
  mounted () {
    this.getData();
  },

  //自定义指令
  directives: {
    drag: {
      // 指令的定义
      bind: function (el, binding) {
        let oDiv = el; // 获取当前元素
        var parentNode = document.getElementById("body");
        oDiv.onmousedown = (e) => {
          // 算出鼠标相对元素的位置
          let disX = e.clientX - oDiv.offsetLeft;
          let disY = e.clientY - oDiv.offsetTop;
          // 缩放指定位置
          var obj = oDiv.getClientRects()[0];
          var left = obj.x + obj.width;
          var top = obj.y + obj.height;
          var click = false;
          if (
            left - 15 < e.clientX &&
            e.clientX < left + 15 &&
            top - 15 < e.clientY &&
            e.clientY < top + 15
          ) {
            click = true;
          }
          // 拿到e对应的index
          // 拿到this.myCharts里面对应的数据，给x、y赋值
          // 自定义指令里不能用this,添加绑定xyChange()方法实现
          document.onmousemove = (e) => {
            binding.value(e, oDiv.id);

            // // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            let left = e.clientX - disX;
            let top = e.clientY - disY;

            if (!click) {
              // 在这里计算 移动div的时候 不能超过body:left 和 top 的位置
              if (left < parentNode.offsetLeft + 3) {
                left = parentNode.offsetLeft + 3;
              } else if (
                left >
                parentNode.clientWidth - oDiv.clientWidth + parentNode.offsetLeft
              ) {
                left =
                  parentNode.clientWidth - oDiv.clientWidth + parentNode.offsetLeft - 4;
              }
              if (top < parentNode.offsetTop + 3) {
                top = parentNode.offsetTop + 3;
              } else if (
                top >
                parentNode.clientHeight - oDiv.clientHeight + parentNode.offsetTop
              ) {
                // top = parentNode.clientHeight - oDiv.clientHeight + parentNode.offsetTop - 55;
                top = parentNode.clientHeight - oDiv.clientHeight + parentNode.offsetTop;
              }

              oDiv.style.left = left + "px";
              oDiv.style.top = top + "px";
            } else {
              var obj = oDiv.getClientRects()[0];
              var left1 = obj.x + obj.width;
              var top1 = obj.y + obj.height;
              var tempW = e.clientX - left1;
              var tempH = e.clientY - top1;
              oDiv.style.width = oDiv.clientWidth + tempW + "px";
              oDiv.style.height = oDiv.clientHeight + tempH + "px";
            }
          };
          document.onmouseup = (e) => {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      },
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      // this.handleAdd();
    }
    // this.getData()
  },
  beforeDestroy(){
    this.myCharts = []
    this.form = {}
    this.xChangeValue = []
    this.yChangeValue = []
  }
};
</script>

<style lang="scss" scoped>
.a {
  background-image: url("../../../assets/dp.png");
  // background-image: url("../../../assets/dpbq.png");
  /* background-image: url("../../../assets/大树.png"); */
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: calc(100% - 130px);
  /* background-image: linear-gradient(to bottom right, #1c0dec, #0d0340, #48aeea); */
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
  /**换行 */
  /* overflow: hidden; */
}

.drag-box {
  position: absolute;
  /* width: 400px;
  height: 400px; */

  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); */
  /* border: 1px solid rgb(236, 233, 233); */
  /* 边框白色 */
  box-shadow: inset 0 0 10px rgb(128, 127, 127);
  /* 阴影 */
  /* box-shadow: 0 0 10px rgb(81, 81, 81); */
  resize: both;
  overflow: hidden;
  border-radius: 5px;
  /**圆角 */
}

.t {
  /* border: 0px; */
  border: none;
  border-bottom: 3px solid #4e7ab8;
  outline: none;
  font-size: 17px;
  width: 99.7%;
  height: 36px;
  background-color: #042974;
  /* background: linear-gradient(blue, #042974 60%); */
  color: aliceblue;
  text-align: center;
  float: left;
  margin-top: 5px;
  /*边距 */
}

.hide {
  display: none;
}

/**下拉框选择器边距 */
// .el-col {
//   padding: 7px 0px;
// }
// el-select .el-input .el-select__caret {
//   margin-right: 19px;
// }
// .el-input--medium .el-input__inner {
//   margin-left: -20px;
// }
// .el-input--suffix .el-input__inner {
//   padding-right: 46px;
// }</style>
